/**
 * Parse feature flags from environment variable
 * Format: VUE_APP_FEATURES=FEATURE_NAME:e,FEATURE_NAME:d
 * where 'e' means enabled and 'd' means disabled
 */
function parseFeatureFlags() {
  const featuresEnv = import.meta.env.VITE_FEATURES;
  const flags = {};

  if (!featuresEnv) {
    return flags;
  }

  const featureEntries = featuresEnv.split(',');

  featureEntries.forEach((entry) => {
    const [featureName, status] = entry.split(':');
    if (featureName && status) {
      flags[featureName.trim()] = status.trim() === 'e';
    }
  });

  return flags;
}

/**
 * Check if a feature flag is enabled.
 * defaultValue applies only when the flag is absent from VITE_FEATURES, so a flag can ship
 * on and still be switched off by adding `NAME:d` to the env list.
 */
function isFeatureEnabled(flagName, defaultValue = false) {
  const flags = parseFeatureFlags();
  return flagName in flags ? flags[flagName] : defaultValue;
}

/**
 * Get all feature flags with their current state
 */
function getAllFeatureFlags() {
  return parseFeatureFlags();
}

/**
 * Get feature flags object for backward compatibility
 */
const featureFlags = getAllFeatureFlags();

export { isFeatureEnabled, getAllFeatureFlags, featureFlags };
